import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=5ac84983&scoped=true"
import script from "./addInfo.vue?vue&type=script&lang=js"
export * from "./addInfo.vue?vue&type=script&lang=js"
import style0 from "./addInfo.vue?vue&type=style&index=0&id=5ac84983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac84983",
  null
  
)

export default component.exports